/**
 * @param obj
 * @param str
 * @param keyTransformer
 * @return {{}}
 */
export default function filterAndStringifyValuesObjectUtil ({
  obj,
  str,
  keyTransformer
}) {
  const filteredObj = {}

  for (const key in obj) {
    if (key.startsWith(str)) {
      const newKey = keyTransformer?.(key) || key
      filteredObj[newKey] = JSON.stringify(obj[key])
    }
  }

  return filteredObj
}
